import api from './api';
export default {
    post(parms) {
        return api.post('company_info/v1',parms)
    },
    postOtherDetails(parms) {
        return api.post('company_info/v1/other_details',parms)
    },
    postNomineeDetails(parms) {
        return api.post('company_info/v1/nominee_details',parms)
    },
    postDownloadPdf(parms) {
        return api.post('company_info/req_doc/pdf',parms)
    }
  }
  